// @ts-nocheck
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";

export const ClearAllTextButton = ({ onClear }) => {
  return (
    <Typography
      onClick={onClear}
      sx={{
        fontSize: "0.8rem",
        px: "1rem",
        width: "100%",
        textAlign: "right",
        cursor: "pointer",
        userSelect: "none",
        "&:hover": {
          textDecoration: "underline",
        },
        "&:active": {
          color: getCssVariableHandler({
            variableName: "--primary-pink-hex",
          }),
        },
      }}
    >
      clear all
    </Typography>
  );
};
ClearAllTextButton.propTypes = {
  onClear: PropTypes.func,
};

export const CustomTextButton = ({ onClick, text, sx }) => {
  return (
    <Typography
      onClick={onClick}
      component={"span"}
      sx={{
        fontSize: "0.8rem",
        px: "1rem",
        width: "100%",
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: "color 0.3 ease",
        "&:hover": {
          textDecoration: "underline",
        },
        "&:active": {
          color: getCssVariableHandler({
            variableName: "--primary-pink-hex",
          }),
        },
        ...(sx || {}),
      }}
    >
      {text}
    </Typography>
  );
};
CustomTextButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  sx: PropTypes.object,
};